<script setup>
import { ref } from 'vue'
import LayoutFooter from '@/components/layout/layoutFooter.vue'
import layoutShell from '@/components/layout/layoutShell.vue'
import compNewsTable from '@/components/news/compNewsTable.vue'
import compNewsStatsPanel from '@/components/news/compNewsStatsPanel.vue'

const tableRef     = ref(null)
const tableFilters = ref({})
</script>
<template>
  <layoutShell>
    <div class="layout-content-wrapper">
      <main class="content">
        <div class="grid">
          <div class="col-12 xl:col-9">
            <compNewsTable ref="tableRef" @filters-change="f => tableFilters = f" />
          </div>
          <div class="col-12 xl:col-3">
            <compNewsStatsPanel
              :active-filters="tableFilters"
              @filter="f => tableRef?.applyExternalFilter(f)"
            />
          </div>
        </div>
      </main>
    </div>
    <div class="layout-footer">
      <LayoutFooter />
    </div>
  </layoutShell>
</template>



